/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { authAvailAlertAxios } from '../utils/availabilityAlertAxios';

export const TIMED_ENTRY_CREATE_AVAILABILITY_ALERT =
    'TIMED_ENTRY_CREATE_AVAILABILITY_ALERT';
export const TIMED_ENTRY_CREATE_AVAILABILITY_ALERT_SUCCESS =
    'TIMED_ENTRY_CREATE_AVAILABILITY_ALERT_SUCCESS';
export const TIMED_ENTRY_CREATE_AVAILABILITY_ALERT_ERROR =
    'TIMED_ENTRY_CREATE_AVAILABILITY_ALERT_ERROR';
export const TIMED_ENTRY_GET_AVAILABILITY_ALERT_COUNTS =
    'TIMED_ENTRY_GET_AVAILABILITY_ALERT_COUNTS';
export const TIMED_ENTRY_GET_AVAILABILITY_ALERT_COUNTS_SUCCESS =
    'TIMED_ENTRY_GET_AVAILABILITY_ALERT_COUNTS_SUCCESS';
export const TIMED_ENTRY_GET_AVAILABILITY_ALERT_COUNTS_ERROR =
    'TIMED_ENTRY_GET_AVAILABILITY_ALERT_COUNTS_ERROR';
export const TIMED_ENTRY_GET_AVAILABILITY_ALERTS = 'TIMED_ENTRY_GET_AVAILABILITY_ALERTS';
export const TIMED_ENTRY_GET_AVAILABILITY_ALERTS_SUCCESS =
    'TIMED_ENTRY_GET_AVAILABILITY_ALERTS_SUCCESS';
export const TIMED_ENTRY_GET_AVAILABILITY_ALERTS_ERROR =
    'TIMED_ENTRY_GET_AVAILABILITY_ALERTS_ERROR';
export const TIMED_ENTRY_RESET_AVAILABILITY_ALERT =
    'TIMED_ENTRY_RESET_AVAILABILITY_ALERT';

export const addAvailabilityAlert = (data) => {
    return async (dispatch) => {
        try {
            dispatch({ type: TIMED_ENTRY_CREATE_AVAILABILITY_ALERT });
            const response = await authAvailAlertAxios.post(`config/add`, data);
            const availabilityAlert = response?.data;
            dispatch({
                type: TIMED_ENTRY_CREATE_AVAILABILITY_ALERT_SUCCESS,
                payload: availabilityAlert,
            });
            return Promise.resolve(response);
        } catch (error) {
            let errorMessage = 'There is a problem in trying to create your alert.';

            if (error?.response?.data?.error) {
                errorMessage = error?.response?.data?.error;
            }

            dispatch({
                type: TIMED_ENTRY_CREATE_AVAILABILITY_ALERT_ERROR,
                payload: errorMessage,
            });

            return Promise.reject(error?.response ?? error);
        }
    };
};

export function getAvailabilityAlertCounts(userId) {
    return async (dispatch) => {
        try {
            dispatch({ type: TIMED_ENTRY_GET_AVAILABILITY_ALERT_COUNTS });
            const response = await authAvailAlertAxios.get(`config/user/count/${userId}`);
            const availabilityAlertCounts =
                response?.data?.payload?.inventory?.timedentry;
            dispatch({
                type: TIMED_ENTRY_GET_AVAILABILITY_ALERT_COUNTS_SUCCESS,
                payload: availabilityAlertCounts,
            });
            return Promise.resolve(response);
        } catch (error) {
            let errorMessage =
                'There is a problem in retrieving availability alert information';

            if (error?.response?.data?.error) {
                errorMessage = error?.response?.data?.error;
            }

            dispatch({
                type: TIMED_ENTRY_GET_AVAILABILITY_ALERT_COUNTS_ERROR,
                payload: errorMessage,
            });

            return Promise.reject(error?.response ?? error);
        }
    };
}

export function getAvailabilityAlerts(userId) {
    return async (dispatch) => {
        try {
            dispatch({ type: TIMED_ENTRY_GET_AVAILABILITY_ALERTS });
            const response = await authAvailAlertAxios.get(
                `config/user/getconfig/${userId}`
            );
            const availabilityAlerts = response?.data?.payload;
            dispatch({
                type: TIMED_ENTRY_GET_AVAILABILITY_ALERTS_SUCCESS,
                payload: availabilityAlerts,
            });
            return Promise.resolve(response);
        } catch (error) {
            let errorMessage =
                'There is a problem in retrieving availability alerts information';

            if (error?.response?.data?.error) {
                errorMessage = error?.response?.data?.error;
            }

            dispatch({
                type: TIMED_ENTRY_GET_AVAILABILITY_ALERTS_ERROR,
                payload: errorMessage,
            });

            return Promise.reject(error?.response ?? error);
        }
    };
}

export function resetAvailabilityAlerts() {
    return (dispatch) => {
        dispatch({
            type: TIMED_ENTRY_RESET_AVAILABILITY_ALERT,
        });
    };
}
